module.exports = __webpack_public_path__ + "static/media/fybfalxjivqrcwdhz00d.8d55e125.png";